import { AbstractPart3d } from "./AbstractPart3d";
import { MeshStandardMaterial, Vector3 } from "three";
import * as Scenes from "oc-threejs/Scenes";
import * as Commons from "oc-commons/Commons";
import { v3 } from "oc-threejs/short3";
import { Cable } from "./Cable";
import * as Maths3 from "oc-threejs/Maths3";
import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { Stromkabel } from "../arrangement/Stromkabel";

const cableRadius = 0.008;
const steckerRadius = 0.01;
const steckerLength = 0.03;

const materialCache = Commons.cache(
  (color) =>
    new MeshStandardMaterial({
      color,
    })
);

export class Stromkabel3d extends AbstractPart3d {
  CLASS_NAME = "Stromkabel3d";
  declare jaco: Stromkabel;

  cables: Cable[] = [];

  constructor(jaco: Jaco) {
    super(jaco);
    this.tapable = false;
    this.position.copy(jaco.position);
  }

  update3d() {
    super.update3d();

    if (
      this.changed("color") ||
      this.changed("pfad") ||
      this.changed("startAnschluss") ||
      this.changed("endAnschluss") ||
      this.changed("lichtAnschlüsse")
    ) {
      const cableMaterial = materialCache(this.jaco.color);

      this.cables.forEach((cable) => Scenes.remove(cable));
      this.cables = [];

      const addCable = (cablePath: Vector3[], radius = cableRadius) => {
        const cable = new Cable(cablePath, cableMaterial, radius);
        this.cables.push(cable);
        this.add(cable);
      };
      const addStecker = (anschluss: Vector3, richtungsPunkt: Vector3) => {
        const d = richtungsPunkt.clone().sub(anschluss).normalize();
        const kabelPunkt = anschluss.clone().addScaledVector(d, +steckerLength * 0.6);
        const vorne = anschluss.clone().addScaledVector(d, -steckerLength * 0.4);
        addCable([vorne, kabelPunkt], steckerRadius);
      };

      // ein langes, durchgehendes Buskabel
      const path: Vector3[] = this.jaco.pfad;
      if (path.length > 0) {
        const busCablePath = [];
        if (this.jaco.startAnschluss == "Trafo") {
          const start = path[0];
          busCablePath.push(start.clone().setY(0));
        }
        busCablePath.push(...path);
        addCable(busCablePath);

        if (this.jaco.startAnschluss == "Bus") {
          addStecker(path.at(0), path.at(1));
        }
        if (this.jaco.endAnschluss == "Bus") {
          addStecker(path.at(-1), path.at(-2));
        }
      }

      this.jaco.lichtAnschlüsse.forEach((end, index) => {
        const trafo = this.jaco.trafo;
        // pro Trafo geht jedes Anschlusskabel leicht versetzt in einem anderen Winkel in den Pfosten,
        // damit man den Fall mehrerer Kabel verschiedener Trafos an einem Pfosten
        // unterscheiden kann
        const x1 = steckerLength + 0.04;
        const x2 = 0.02;
        const y1 = end.y + 0.005;
        const y2 = -0.02;
        const y3 = 0.1;
        const angle = ((80 + 30 * trafo.treeIndex) * Math.PI) / 180;
        const xz1 = v3(x1, 0, 0).applyAxisAngle(Maths3.vector.y, angle);
        const xz2 = v3(x2, 0, 0).applyAxisAngle(Maths3.vector.y, angle);
        const p1 = end.clone().setY(y1).add(xz1);
        const p2 = end.clone().setY(y2).add(xz1);
        const p3 = end.clone().setY(y2).add(xz2);
        const p4 = end.clone().setY(y3).add(xz2);
        const cablePath = [end, p1, p2, p3, p4];
        addCable(cablePath);
        addStecker(end, p1);
      });
    }
  }

  toJSON() {
    return null;
  }

  fromJSON(json) {
    return null;
  }
}
